(function(){
    'use strict';
    angular.module('mso.registration').controller('RegisterCompleteSuccessCtrl', RegisterCompleteSuccessCtrl);

    RegisterCompleteSuccessCtrl.$inject = ['referenceData','$routeParams'];
    function RegisterCompleteSuccessCtrl(referenceData, $routeParams){
        var vm = this;

        // Initialise vm variables
        vm.messages = referenceData.messages;
        vm.parameters = referenceData.parameters;
        vm.referenceData = referenceData.valuesets;
        vm.title = 'Registration Completed Successfully';


        vm.initialMessage = $routeParams.initial;


    }
})();